export default __webpack_public_path__ + "static/ISO-9001-certificate-20230509-2dbd3988d14709bbdc2825c732812bce.pdf";